import React from "react";
import { Section } from "../../../components/section";
import { SectionHeader } from "../../../components/section-header";
import { ParagraphGroup } from "../../../components/paragraph-group";
import { ParagraphTwins } from "../../../components/paragraph-twins";

export interface IConsolidationProps {
  sectionId: string;
  index: number;
}

export function Conclusion(props: IConsolidationProps) {
  const formattedIndex = props.index > 10 ? props.index : `0${props.index}`;
  return (
    <Section sectionId={props.sectionId} isLast={false}>
      <SectionHeader title={`${formattedIndex} Conclusion`} />

      <ParagraphGroup body={["Explore some additional resources."]} />

      <ParagraphTwins
        p1={{
          body: [
            "After our last round of testing, we focused on making adjustments for usability and refining the overall visual design for clarity and consistency. ",
          ],
        }}
        link1={{
          cta: "See our final prototype",
          url:
            "https://www.figma.com/proto/Thyvdlyo8lQTDVGwjvg0fE/Prototype:-Final?page-id=270%3A2927&node-id=274%3A3068&viewport=623%2C362%2C0.05720783770084381&scaling=scale-down&starting-point-node-id=274%3A3068",
        }}
        p2={{
          body: [
            "To further clarify the functionality of our solution, we defined and annotated our final prototype with the current functionality of our prototype, the expected additional functionality if it was to be implemented, and the corresponding AI logic from our models above.",
          ],
        }}
        link2={{
          cta: "View Annotated Prototype",
          url:
            "https://www.figma.com/file/Thyvdlyo8lQTDVGwjvg0fE/Prototype-Final?node-id=207%3A2675",
        }}
      />
    </Section>
  );
}
